import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import Swal from 'sweetalert2';

export default function SweetAlert(props: any) {
  const [rerender, setRerender] = useState(false);

  useEffect(() => {
    if (props.show) {
      mountSwal();

      if (props.showLoading) {
        Swal.showLoading();
      }
    }
  }, [props.show]);

  useEffect(() => {
    if (props.show && props.showLoading) {
      Swal.showLoading();
    } else {
      Swal.hideLoading();
    }
  }, [props.showLoading]);

  useEffect(() => {
    const swalContainer = Swal.getHtmlContainer();
    if (swalContainer) {
      const showContainer = props.text || props.html || props.children;
      swalContainer.style.display = showContainer ? 'block' : 'none';
    }
  }, [props.text, props.html, props.children]);

  function mountSwal() {
    const {
      show,
      showLoading,
      onConfirm,
      willOpen,
      onResolve,
      onError,
      children,
      ...rest
    } = props;
    delete rest['onClose']

    rest['willOpen'] = (el) => {
      setRerender(!rerender);
      willOpen && willOpen(el);
    };

    Swal.fire(rest)
      .then((result) => {
        if (result.isConfirmed) {
          onConfirm && onConfirm(result);
        }

        props.onClose();

        onResolve && onResolve(result);
      })
      .catch((error) => onError && onError(error));
  }

  const swalContainer = Swal.getHtmlContainer();

  if (swalContainer && !props.html && props.show) {
    return ReactDOM.createPortal(props.children, swalContainer);
  }

  return <></>;
}
